import script from "./CustomSearchDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomSearchDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./CustomSearchDropdown.vue?vue&type=style&index=0&id=5f813178&scoped=true&lang=scss"
import "./CustomSearchDropdown.vue?vue&type=style&index=1&id=5f813178&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f813178"]])

export default __exports__